import DecisionTreeRouter from './DecisionTreeRouter';
import StyledBox from './styles';

function DecisionTreeWindow() {
  return (
    <StyledBox>
      <DecisionTreeRouter />
    </StyledBox>
  );
}

export default DecisionTreeWindow;
